import { useQuery } from '@tanstack/react-query';
import { getInstallationDetails } from '@services/cpqService';
import type { InstallationDetailsResponse } from '@t/checkout.types';

type Options = {
  enabled: boolean;
};

export const useInstallationDetails = (sessionId: string | null, { enabled }: Options) => {
  const query = useQuery<InstallationDetailsResponse>({
    queryKey: ['installationDetails', sessionId],
    queryFn: () => getInstallationDetails(sessionId!),
    enabled: !!sessionId && enabled,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const data = query.data ?? null;

  return {
    installationDetailsData: data,
    serviceTypeResult: data?.serviceTypeResult ?? null,
    technicianOptions: data?.serviceTypeResult?.technicianOptions ?? [],
    pickupAddress: data?.installationDetails?.pickupAddress ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
